import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './js/router'
import store from './js/store'
import http from './js/http'
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import VueI18n from 'vue-i18n';

var lang = (window.navigator.languages && window.navigator.languages[0]) ||
            window.navigator.language ||
            window.navigator.userLanguage ||
            window.navigator.browserLanguage;
if(Object.keys(store.getters.langs).indexOf(lang) === -1){
  lang = "en";
}
var messages = {};
for(let l of Object.keys(store.getters.langs)){
  messages[l] = require('./lang/' + l + '.json');
  try{
    messages[l].error = require('./shared/error/' + l + '.json').error;
  }catch(e){
    console.log("load error:" + e);
  }
}
const dateTimeFormats = require('./lang/dateTimeFormats.json');
const numberFormats = require('./lang/numberFormats.json');
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: lang,
  messages: messages,
  fallbackLocale: 'en',
  dateTimeFormats: dateTimeFormats,
  numberFormats: numberFormats
});

Vue.config.productionTip = false;
Vue.use(http, { store, router });
Vue.filter('comma_digit', function (value) {
  return Number(value).toLocaleString();
});

new Vue({
  router,
  store,
  vuetify,
  render: function (h) { return h(App) },
  i18n: i18n
}).$mount('#app');

router.beforeResolve((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  var invalid_domains = [];
  if(to.matched.length > 0){
    invalid_domains = to.matched[0].meta.invalid_domains;
  }
  if(from.name === null
    && to.path !== "/"
    && to.name !== "auth_callback"){
    // URL貼り付けの場合
    next('/?redirect=' + encodeURIComponent(to.fullPath));
  }else if (requiresAuth) {
      if(store.getters.user){
        if(invalid_domains.indexOf(store.getters.user.domain) >= 0){
          next('/');
        }else{
          next();
        }
      }else{
        next('/');
      }
  } else {
    next();
  }
});
router.afterEach((to, from) => {
  var id_less_path = to.fullPath.split("#")[0].replace(/([A-Z]\d{5,})/g, function(){
    for(var arg of arguments){
      return arg[0] + "x".repeat(arg.length - 1);
    }
  })
  window.dataLayer.push({
    'trackPageview': id_less_path,
    'event': 'loadready'
  });
})
